module.exports = __webpack_public_path__ + "img/loesungen-fuer-jede-lebenslage_kachl_DAILYESSENTIALS.8ce3afa9.png";